<template>
  <div>
    <PromotionHeader :img_header="header_image" header="ตั้งกลุ่มสินค้าคละใหม่" link_back="stock/promotion_stock/promotionassorted" />
    <Promotion_add_group/>
  </div>
</template>

<script>
import PromotionHeader from "@/components/admin/stock/storage_promotion/header_promotion/PromotionHeader";
import Promotion_add_group from "@/components/admin/stock/storage_promotion/Promotion_add_group";
import HeaderImage from "@/assets/boxes_random.png";
export default {
  name: "PromotionAddGroup",
  components: {
    Promotion_add_group,
    PromotionHeader
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  },
}
</script>

<style scoped>

</style>
